<template>
  <div>
    <div class="ts-space-y-4">
      <div class="ts-grid ts-grid-cols-2 ts-gap-2">
        <p class="ts-text-right ts-mb-0">{{ $t('gameSetResult.gameSettingName') + ' : ' }}</p>
        <p class="ts-mb-0">
          <span class="ts-text-red-600 ts-font-semibold">{{ gameinput.game_setting_name }}</span>
        </p>
        <p class="ts-text-right ts-mb-0">{{ $t('gameSetResult.drawTime') + ' : ' }}</p>
        <p class="ts-mb-0">
          <span class="ts-text-red-600 ts-font-semibold">{{ gameinput.draw_time }}</span>
        </p>
      </div>
      <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4 ts-pb-5">
        <div class="ts-flex ts-space-x-4 ts-mx-auto" style="width:fit-content">
          <input
            v-for="(result, index) in model.result_number"
            :key="index"
            v-model="result.value"
            type="number"
            class="ts-text-center ts-font-semibold ts-text-base ts-border-b-2 ts-px-2 ts-py-1 ts-outline-none ts-w-12"
            :class="errors.has('result_number.' + index + '.value') ? 'ts-border-red-600' : 'ts-border-blue-600'"
          />
        </div>
      </div>
      <div class="ts-flex ts-justify-end ts-space-x-4">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" @click.prevent="onUpdate">{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import pwdConfirm from './confirm'

export default {
  name: 'frmUpdate',
  props: ['gameinput'],
  components: {
    pwdConfirm
  },
  data() {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      game_sets: [],
      model: {
        password: null,
        result_id: 0,
        game_type_id: null,
        game_set_id: null,
        result_number: []
      }
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    ...mapActions('administrator/gameSetResult', ['update']),
    setEditData() {
      if (!_.isEmpty(this.gameinput)) {
        this.model.result_id = this.gameinput.result_temp_id
        this.model.game_type_id = this.gameinput.game_type_id
        this.model.game_set_id = this.gameinput.game_set_id
        this.model.result_number = this.gameinput.result_number
          .split(',')
          .map(el => ({
            value: parseInt(el)
          }))
      }
    },
    onUpdate() {
      this.errors = new Errors()
      this.$confirm({
        title: null,
        content: h =>
          h(pwdConfirm, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('gameSetResult.password')
            }
          }),
        zIndex: 1025,
        centered: true,
        okText: this.$t('confirm'),
        icon: 'success',
        onOk: () => {
          return this.update({
            id: this.model.result_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.$emit('close')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>